<template>
  <div class="honor">
    <Title :title="title" class="title" />
    <div class="container">
      <div class="swiper">
        <swiper :options="swiperOption" ref="honorSwiper" id="honorSwiper">
          <swiper-slide v-for="item in honor" :key="item.ID">
            <a :href="'http://donghao.chinadonghao.com/upload/'+item.BIGURL"><img :src="'http://donghao.chinadonghao.com/upload/'+item.PICURL" alt=""></a>
          </swiper-slide>
        </swiper>
        <div class="el-icon-arrow-left"></div>
        <div class="el-icon-arrow-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '../Title/Title.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { mapState } from 'vuex'
import { getPicUrl } from '@/util/lang.js'
export default {
  components: {
    Title,
    swiper,
    swiperSlide
  },
  data() {
    return {
      title: {
        cn: '资质荣誉',
        en: 'Qualification honor'
      },
      swiperOption:{
        notNextTick: true,
        loop: true,
        slidesPerView: 3,
        centeredSlides: true,
        init: false,
        navigation: {
          nextEl: '.honor .swiper .el-icon-arrow-right',
          prevEl: '.honor .swiper .el-icon-arrow-left',
        }
      },
      honor: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  watch: {
    lang: 'fetchDate'
  },
  mounted () {
    this.fetchDate(this.lang)
  },
  methods: {
    fetchDate (val) {
      if (val) {
        const url = getPicUrl(this.lang, '资质荣誉', '10')
        this.$$axios.get(url).then(res => {
          this.honor = res.data
          this.$refs.honorSwiper.swiper.init()
        }).then(()=>{
          baguetteBox.run('.swiper', {
            animation: 'fadeIn',
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.honor{
  position: relative;
  z-index: 1;
}
.honor .title{
  max-width: 840px;
  margin-left: auto;
  margin-right: auto;
  border-bottom: 1px solid #c6c6c6;
  padding: 40px 0;
}
.honor .container{
  max-width: 1500px;
  margin: 0 auto;
  padding: 50px 0;
}
.honor .swiper{
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}
.swiper-container{
  padding: 50px 0;
}
.honor .swiper .swiper-slide{
  transition: .3s;
}
.honor .swiper .swiper-slide img{
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
.honor .swiper .swiper-slide-active{
  transform: scale(1.2);
  z-index: 2;
}
.honor .swiper .el-icon-arrow-left,.honor .swiper .el-icon-arrow-right{
  position: absolute;
  top: 50%;
  margin-top: -17px;
  font-size: 18px;
  line-height: 34px;
  width: 34px;
  height: 34px;
  background-color: #005598;
  border-radius: 50%;
  text-align: center;
  color: #fff;
  z-index: 2;
  cursor: pointer;
  outline: none;
}
.honor .swiper .el-icon-arrow-left{
  left: 0;
}
.honor .swiper .el-icon-arrow-right{
  right: 0;
}
</style>


